import classNames from 'classnames';
import React, { useState } from 'react';
import { useModal } from 'react-modal-hook';
import { useHistory, useParams } from 'react-router';
import { TemplateClassNames } from '../../../../../types/template-layouts';
import { PageModule, Speaker } from '../../../../../types/working-model';
import { getTextValue } from '../../../../../utils/utils';
import { TypographyItem } from '../../../../general-ui/typography-item/typography-item';
import { SpeakerDetailsModal } from '../../../containers/speaker-details-modal/speaker-details.modal';
import { ParamsProps } from '../../../live-event';
import { getStylingOverrides } from '../../../utils';
import { ETabLayoutClassNames } from '../../session';
import SpeakerCard from './speaker-card';
import './speakers.scss';

interface ISpeakerProps {
	module: PageModule;
	template: TemplateClassNames;
	tabLayout: ETabLayoutClassNames;
}

const SessionSpeakers: React.FC<ISpeakerProps> = ({ module, template, tabLayout }) => {

	const stylingOverrides = getStylingOverrides(module?.styling_overrides);

	const { content } = module;
	const params: ParamsProps = useParams();
	const { language } = params;
	const history = useHistory();

	const [speaker, setSpeaker] = useState<Speaker>();

	const {
		customHeadingOverrides
	} = stylingOverrides;

	const [showSpeakerDetailsModal, hideSpeakerDetailsModal] = useModal(
		() => {
			const _relatedSessions = content?.related_sessions?.find((item: any) => item.speaker === speaker?.speaker);
			return (
				<SpeakerDetailsModal
					template={template}
					onClose={hideSpeakerDetailsModal}
					language={language}
					speaker={speaker as Speaker}
					stylingOverrides={stylingOverrides}
					relatedSessions={_relatedSessions?.sessions ?? []}
					params={params}
					onRelatedSessionClick={history.push}
				/>
			);
		}, [speaker]);

	const { custom_heading } = getTextValue(content, language);

	if (!module.modules) return null;
	return (
		<div className={classNames(
			'session-module speakers',
			`speakers-${tabLayout}-tabs`,
			stylingOverrides.backgroundColor,
			template
		)}
			style={stylingOverrides.backgroundImg}

		>
			<div className="container">
				<TypographyItem
					tagName="h5"
					template={template}
					className={classNames(
						"evt-heading-5 speakers-title",
						customHeadingOverrides,
					)}
				>
					{custom_heading}
				</TypographyItem>
				<div className="speakers-list">
					{
						module?.modules?.map((speaker: Speaker) => (
							<SpeakerCard
								onClick={(speaker) => {
									setSpeaker(speaker);
									showSpeakerDetailsModal();
								}}
								key={speaker.speaker}
								speaker={speaker}
								template={template}
							/>))
					}
				</div>
			</div>
		</div>
	);
};

export default SessionSpeakers;
